<script>
    import stamp from './stamp.txt';

    export default {
        render (h) {
            return h('div', {
                staticClass: 'stamp',
                domProps: {
                    innerHTML: stamp
                }
            });
        }
    }
</script>
